module.exports = __webpack_public_path__ + "1.0.0-fa265927/img/solr.f453ed60.svg";